import '@/main.scss'
import '@/directives/activate-on-scroll.js'

import Vue from 'vue'
import VueTouch from 'vue-touch/dist/vue-touch'

import router from './router'

Vue.use(VueTouch, {name: 'v-touch'})
Vue.config.productionTip = false

export default new Vue({
  el: '#app',
  router,
  render: h => h('router-view')
})



// WEBPACK FOOTER //
// ./src/main.js